module.exports = __webpack_public_path__ + "img/profile2.54affa2c.jpg";